/* eslint-disable i18next/no-literal-string */
import React from "react";
import {
  Avatar,
  Box,
  Flex,
  Group,
  Stack,
  ThemeIcon,
  Text,
  Image,
} from "@mantine/core";
import { IconCaretLeftFilled, IconBookmark } from "@tabler/icons-react";

import type { StandardArticleContent } from "@typings/parentapp-feed-types";

interface StandardArticleProps {
  content: StandardArticleContent;
  isAssociatedWithPlayer: boolean;
}

export const StandardArticle: React.FC<StandardArticleProps> = (props) => {
  const imgUrl = props.content.image?.url;

  return (
    <Box>
      {/* image at top */}
      {imgUrl ? <Image src={imgUrl} /> : null}

      <Flex justify="space-between" px="md" pt="md">
        <ThemeIcon variant="filled" radius="xl">
          <IconCaretLeftFilled />
        </ThemeIcon>

        <Stack flex={1} justify="center" align="center" gap="xs">
          <Text fw="bold">{props.content.headerText}</Text>

          <Group>
            {props.isAssociatedWithPlayer ? (
              <Avatar color="cyan" radius="xl" size="sm">
                AP
              </Avatar>
            ) : null}

            <ThemeIcon variant="transparent">
              <IconBookmark />
            </ThemeIcon>
          </Group>
        </Stack>
      </Flex>

      {/* main text/content section (i.e. the HTML from iterable) */}
      <Box p="sm" px="lg">
        <Text>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Rerum,
          dolores voluptatum. Molestiae unde quasi dolore ex magnam nobis, odio
          mollitia fugiat omnis quaerat sit?
        </Text>
        <br />
        <Text>
          Ratione repellat nam soluta aliquid temporibus consectetur quis
          distinctio iste! Vel similique exercitationem voluptatem, accusamus
          maxime voluptate excepturi molestiae itaque ab sed totam, aut
          reprehenderit at.
        </Text>
      </Box>
    </Box>
  );
};
